import { render, staticRenderFns } from "./ValorVencer.vue?vue&type=template&id=fe7e225c&scoped=true&"
import script from "./ValorVencer.vue?vue&type=script&lang=js&"
export * from "./ValorVencer.vue?vue&type=script&lang=js&"
import style0 from "./ValorVencer.vue?vue&type=style&index=0&id=fe7e225c&scoped=true&lang=css&"
import style1 from "./ValorVencer.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7e225c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
